import React from "react";
import WebService from "api/explus-api";
import Home from "./Home";
import Loader from "../../Loader/Loader";
import swal from "sweetalert2";
import popbg from "../../../assets/img/banner/donate_covid_300x300.jpg";
import "../../../assets/css/swal.css";


// import swal from "sweetalert2";

class HomeContainer extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            partner: {},
            childData: {},
            childUrl: "",
            loaded: false
        };

        this.handler = this.handler.bind(this);
    }

    componentDidMount() {
        let childData = "";

        const expiry = localStorage.getItem('donate_popup_expiry');
        const donationPop = localStorage.getItem('donate_popup');

        if (expiry && expiry < Date.now()) {
            localStorage.removeItem('donate_popup');
            localStorage.removeItem('donate_popup_expiry');
        }

        if (!donationPop) {

            localStorage.setItem('donate_popup', 'true');
            const theDate = new Date();
            localStorage.setItem('donate_popup_expiry', theDate.setDate(theDate.getDate() + 10));

            // swal.fire({
            //     // title: "ADVISORY",
            //     // background: "#000",
            //     text: "You can send much-needed help to equip families by providing them supplies which they can use to fight the COVID-19 pandemic. ",
            //     // type: "info",
            //     imageUrl: popbg,
            //     confirmButtonText: "Click Here",
            //     customClass: {
            //         popup: 'popup-donation',
            //         confirmButton: 'donate-btn',
            //         content: 'donate-content',
            //     }
            // }).then((result) => {
            //     if (result.value) {
            //         window.location.href = 'https://www.worldvision.org.ph/donate/covid-19-emergency-health-response/?utm_medium=myspon_popup';
            //     }
            // });

        }

        // this.countChildren();

        // if (!this.state.childData) {
        // this.showAdvisory();
        // }

        this.getChild().then(data => {
            if (typeof data.status !== "undefined" || data.status === "error") {
                return;
            }

            childData = data;

            if (childData.child === "") {
                this.setState({ loaded: true });
                return;
            }

            this.getProjects(childData.childProjectId).then(data => {
                childData.project = data;
                this.setState({ childData });

                this.getAdpVideo();

                // this.setState({loaded: true})

                // -----------------------------------------------------
                // ---GET IMAGES----------------------------------------
                // -----------------------------------------------------
                this.getChildImage(childData.child);

                // Get Partner details
                // this.checkCache('partner')
            });
        });

        this.getPartner();
    }

    countChildren = () => {
        WebService.ajaxGet("v2/child/child-count")
            .then(res => {
                this.setState({ childrenCount: res });
            })
            .catch(err => {
                // console.log(err);
                console.log("Error");
            });
    };

    handler(pageNumber) {
        return event => {
            event.preventDefault();
            let childData = "";

            if (pageNumber !== "") {
                this.setState({ loaded: false });
            }

            return this.getChild(pageNumber).then(data => {
                if (
                    typeof data.status !== "undefined" ||
                    data.status === "error"
                ) {
                    return;
                }
                childData = data;

                return this.getProjects(childData.childProjectId).then(data => {
                    childData.project = data;

                    // if (this.props.match.url === '/dashboard') {
                    this.setState({ childData });
                    this.setState({ loaded: true });
                    // -----------------------------------------------------
                    // ---GET IMAGES----------------------------------------
                    this.getChildImage(childData.child);
                    // }
                });
            });
        };
    }

    extractProjectIdFromChild(childId) {
        if (!childId) {
            return;
        }

        let projectId = "";
        projectId = childId.split("-");
        return (projectId = projectId[0]);
    }

    //---------------------------------------------------------------
    //------- GET PARTNER DETAILS -----------------------------------
    //---------------------------------------------------------------
    getPartner() {
        WebService.getPartner().then(res => {
            const state = "partner";
            this.setState({ [state]: res });
            this.setState({ loaded: true });
            // sessionStorage.setItem(state, JSON.stringify(res))
        });
    }

    // check if cached version is available
    checkCache(cacheKey) {
        // if (sessionStorage.getItem(cacheKey)) {
        //   this.setState({[cacheKey]: JSON.parse(sessionStorage.getItem(cacheKey))})
        //   this.setState({loaded: true})
        // } else {
        //   switch (cacheKey) {
        //     case 'partner':
        //       this.getPartner()
        //       return
        //     default:
        //       return
        //   }
        // }
    }

    //---------------------------------------------------------------
    //------- GET CHILD PHOTO ---------------------------------------
    //---------------------------------------------------------------
    getChildImage(child) {
        const id = "/" + child.child_id; // 2 web optimised image

        WebService.ajaxGet("web/childphoto" + id).then(data => {
            let imageUrl = "";

            if (typeof data[2] !== "undefined") {
                imageUrl = data[2].url;
            }

            this.setState(prevState => ({
                childData: {
                    ...prevState.childData,
                    childPhoto: imageUrl
                }
            }));
        });
    }

    //---------------------------------------------------------------
    //------- GET CHILD ---------------------------------------------
    //---------------------------------------------------------------
    getChild(urlWithPageNumber) {
        let endpoint = 1; // defaults to page 1

        if (typeof urlWithPageNumber !== "undefined") {
            endpoint = urlWithPageNumber;
        }
        
        const url = 'web/children?per_page=1&page=' + endpoint;

        //return WebService.ajaxGet("web/children?per_page=1", endpoint).then(
        return WebService.ajaxGet(url).then(
            data => {
                if (typeof data.data === "undefined") {
                    this.setState({ errors: data });
                    return { status: "error" };
                }

                let child = data.data[0] ? data.data[0] : "";
                let childProjectId = child.child_id ? child.child_id : "";

                const fetchedData = {
                    child: child,
                    childProjectId: this.extractProjectIdFromChild(
                        childProjectId
                    ),
                    nextPage: data.next_page_url,
                    prevPage: data.prev_page_url
                };

                return fetchedData;
            }
        );
    }

    //---------------------------------------------------------------
    //------- GET PROJECTS ------------------------------------------
    //---------------------------------------------------------------
    getProjects(childPid) {
        if (!childPid) {
            return;
        }
        // const pid = '[' + childPid + ']'
        const pid = childPid;

        return WebService.ajaxGet("web/projects/" + pid).then(data => {
            return data[0];
        });
    }

    //---------------------------------------------------------------
    //------- DISPLAY CHILDDATA -------------------------------------
    //---------------------------------------------------------------
    childData() {
        let content = "";

        if (this.state.loaded === false) {
            return (content = <Loader />);
        }

        const child = this.state.childData.child;

        if (typeof child === "undefined") {
            content = <Home sponsor={this.state.partner} noChild="true" />;
        } else {
            content = (
                <Home
                    childrenCount={this.state.childrenCount}
                    prevChild={this.state.childData.prevPage}
                    nextChild={this.state.childData.nextPage}
                    sponsor={this.state.partner}
                    child={this.state.childData.child}
                    childPhoto={this.state.childData.childPhoto}
                    project={this.state.childData.project}
                    handler={this.handler}
                    adpVideo={this.state.adpVideo}
                />
            );
        }

        return content;
    }

    getAdpVideo = () => {
        const projectId = this.state.childData.childProjectId;

        if (projectId === undefined) return;

        return WebService.requestGet(
            window.donationUrl + "adp/get-adp-video?project_id=" + projectId
        ).then(data => {
            this.setState({ adpVideo: data.adp_video });
        });
    };

    render() {
        return <div>{this.childData()}</div>;
    }
}

export default HomeContainer;
